import { queryClient } from './queryClient';
import axios, { refreshAxiosCache } from './axios';

/**
 * Account-scoped prefs written without a user/store id prefix.
 * Cleared on logout/login switch so Account B never inherits Account A UI state.
 * Keep: i18nextLng, isDarkMode, referral_code (global prefs / marketing).
 */
const ACCOUNT_LOCAL_KEYS = [
  'user',
  'accessToken',
  'store-id',
  'country-id',
  'country-dial-code',
  'country-iso',
  'identity_color',
  'products_show_method',
  'default_page',
  'isMaltyBranches',
  'needsMainSettings',
  'isPrivatePackage',
  'createdYear',
  'showOnboardingInstructions',
];

/**
 * Wipe in-memory API cache + account localStorage for the previous session.
 * Safe to call on logout, delete-account, forced 401, and successful login.
 */
export function clearAccountSession({ clearAuth = true } = {}) {
  try {
    queryClient.clear();
  } catch (_) {
    /* ignore if called before QueryClient is ready */
  }

  ACCOUNT_LOCAL_KEYS.forEach((key) => {
    if (!clearAuth && (key === 'user' || key === 'accessToken' || key === 'store-id' || key === 'country-id')) {
      return;
    }
    try {
      localStorage.removeItem(key);
    } catch (_) {
      /* ignore */
    }
  });

  // firstTimeModal_* is store-scoped (OK to keep across accounts for same store id,
  // but wipe all to avoid leaking UX flags if store ids collide)
  try {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('firstTimeModal_')) {
        localStorage.removeItem(key);
      }
    });
  } catch (_) {
    /* ignore */
  }

  try {
    sessionStorage.removeItem('onboarding-welcome-pending');
  } catch (_) {
    /* ignore */
  }

  if (clearAuth) {
    try {
      delete axios.defaults.headers.common.Authorization;
    } catch (_) {
      /* ignore */
    }
  }

  refreshAxiosCache();
}

export default clearAccountSession;
